// Generated by BUCKLESCRIPT VERSION 5.0.4, PLEASE EDIT WITH CARE


function strip0x(y) {
  var match = y.startsWith("0x");
  if (match) {
    return y.substr(2);
  } else {
    return y;
  }
}

function strip0x1(y) {
  var match = y.startsWith("0x");
  if (match) {
    return y.substr(2);
  } else {
    return y;
  }
}

export {
  strip0x ,
  strip0x1 ,
  
}
/* No side effect */
